export const DEFAULT_NAMESPACE = 'translation';
export const DEFAULT_LANGUAGE_CODE = 'en';
export const DEFAULT_COUNTRY_CODE = 'GB';
export const DEFAULT_LOCALE = `${DEFAULT_LANGUAGE_CODE}-${DEFAULT_COUNTRY_CODE}`;
